import React from "react";

import Tool from "../Tool";

import polygonIcon from "../../../../../assets/paint/polygon.png";

const Polygon = () => (
  <Tool icon={polygonIcon} toolType="poly" data-test="tool" notImplemented />
);

export default Polygon;
